<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">ANEXOS</span>
                    </b-card-header>
                    <b-card-body>
                        <app-tabela
                            idTabela="tblAnexos"
                            :itens="entrega.anexos"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                        >
                            <template slot="botoes">
                                <b-button-group class="float-right">
                                    <b-button
                                        variant="success"
                                        @click.stop="inserirEntregaAnexo()"
                                        v-if="mostrarBtnInserirAnexo"
                                    >Inserir Anexo</b-button>
                                </b-button-group>
                                <slot name="botoes"></slot>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <app-entrega-anexo-download
                                    :entregaAnexo="data"
                                    :entregasServicos="entregasServicos"
                                ></app-entrega-anexo-download>
                                <app-entrega-anexo-exlcuir
                                    :entregaStatus="entrega.status"
                                    :entregaAnexo="data"
                                    :entregasServicos="entregasServicos"
                                    @obterEntregaAtualizada="obterEntregaAtualizada()"
                                ></app-entrega-anexo-exlcuir>
                                <slot name="acoes" v-bind="data"></slot>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <app-entrega-anexo-form
            ref="entregaAnexoForm"
            @obterEntregaAtualizada="obterEntregaAtualizada()"
            :entrega="entrega"
            :entregasServicos="entregasServicos"
        ></app-entrega-anexo-form>
    </div>
</template>

<script>
import EntregaAnexoDownload from './EntregaAnexoDownload'
import EntregaAnexoForm from './EntregaAnexoForm'
import EntregaAnexoExcluir from './EntregaAnexosExcluir'

export default {
	props: {
		entrega: {
			type: Object,
			default: () => ({})
		},

		entregasServicos: {
			type: Object,
			required: true,
			default: () => ({})
		}
	},

	data() {
		return {
			campos: [
				{
					key: 'tipoDescr',
					label: 'Tipo',
					sortable: true,
					filterable: true
				},
				{
					key: 'descritivo',
					label: 'Descritivo',
					sortable: true,
					filterable: true
				},
				{
					key: 'nomeArquivoOriginal',
					label: 'Arquivo'
				},
				{
					key: 'dataAtualizacao',
					label: 'Atualizado em',
					type: 'datetime'
				},
				{
					key: 'acoes',
					label: 'Ações'
				}
			],
			itensPorPagina: 0
		}
	},

	methods: {
		obterEntregaAtualizada() {
			this.$emit('obterEntregaAtualizada')
		},

		inserirEntregaAnexo() {
			this.$refs.entregaAnexoForm.mostrarModalEntregaAnexoForm = true
		}
	},

	computed: {
		mostrarBtnInserirAnexo() {
			return (
				this.$temAcesso('CRED-FORN-ENTR-02') &&
				(this.entrega.status === 0 || this.entrega.status === 3)
			)
		}
	},

	components: {
		AppEntregaAnexoDownload: EntregaAnexoDownload,
		AppEntregaAnexoForm: EntregaAnexoForm,
		AppEntregaAnexoExlcuir: EntregaAnexoExcluir
	}
}
</script>
